var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: _vm.url, params: { slug: _vm.slug } }}},[_c('img',{staticClass:"column rounded",attrs:{"src":_vm.mediaUrl + '/' + _vm.poster}})])
}
var staticRenderFns = []

export { render, staticRenderFns }